const UPSELL_WRAPPER_SELECTOR = '[data-cart-drawer-upsells]';
const UPSELL_LIST_SELECTOR = '[data-cart-drawer-upsells-list]';
const CART_LINE_SELECTOR = '[data-cart-line][data-product-id]';
const SECTION_ID = 'cart-drawer-upsells';
const MAX_UPSELLS = 4;
const PER_PRODUCT_LIMIT = 4;

const getStoreRoot = () => window.Shopify?.routes?.root || '/';

const getStoreUrl = (path = '') => new URL(path, window.location.origin + getStoreRoot()).toString();

const getCartProductIds = () =>
  [...document.querySelectorAll(CART_LINE_SELECTOR)].map((line) => line.dataset.productId).filter(Boolean);

const fetchUpsellCards = async (productId) => {
  const url = getStoreUrl(
    `recommendations/products?section_id=${SECTION_ID}&product_id=${productId}&intent=complementary&limit=${PER_PRODUCT_LIMIT}`
  );

  const response = await fetch(url, { headers: { Accept: 'text/html' } });
  if (!response.ok) return [];

  const html = await response.text();
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  return [...parsed.querySelectorAll('[data-cart-upsell-card]')];
};

const renderUpsells = async () => {
  const wrapper = document.querySelector(UPSELL_WRAPPER_SELECTOR);
  const list = wrapper?.querySelector(UPSELL_LIST_SELECTOR);
  if (!(wrapper instanceof HTMLElement) || !(list instanceof HTMLElement)) return;

  const cartProductIds = getCartProductIds();
  if (!cartProductIds.length) {
    wrapper.hidden = true;
    list.replaceChildren();
    return;
  }

  try {
    const groups = await Promise.all([...new Set(cartProductIds)].map(fetchUpsellCards));

    // Exclude products already in the cart, then dedupe across sources.
    const seen = new Set(cartProductIds);
    const cards = [];

    for (const group of groups) {
      for (const card of group) {
        const id = card.dataset.upsellProductId;
        if (!id || seen.has(id)) continue;
        seen.add(id);
        cards.push(card);
        if (cards.length >= MAX_UPSELLS) break;
      }
      if (cards.length >= MAX_UPSELLS) break;
    }

    list.replaceChildren(...cards);
    wrapper.hidden = cards.length === 0;
  } catch (error) {
    wrapper.hidden = true;
    list.replaceChildren();
    console.error(error);
  }
};

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-cart-upsell-add]');
  if (!(button instanceof HTMLElement)) return;

  event.preventDefault();
  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.setAttribute('aria-disabled', 'true');

  try {
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    const response = await fetch(getStoreUrl('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body,
      credentials: 'same-origin',
    });

    if (!response.ok) {
      const payload = await response.json().catch(() => ({}));
      throw new Error(payload?.description || payload?.message || 'Add to cart failed');
    }

    document.dispatchEvent(new CustomEvent('cart:section-refresh-request'));
  } catch (error) {
    console.error(error);
  } finally {
    button.removeAttribute('aria-disabled');
  }
});

document.addEventListener('cart:updated', () => void renderUpsells());

document.addEventListener('drawer:opened', (event) => {
  if (event.detail?.id !== 'cart-drawer') return;
  void renderUpsells();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => void renderUpsells());
} else {
  void renderUpsells();
}
